import { useCurrentClient } from "hooks/api/use-clients";
import classNames from "classnames";

import { useThemePreviewContext } from "containers/admin/clients/client/theme-page/contexts/theme-preview-context";
import PreviewAreaHeader from "containers/admin/clients/client/theme-page/preview/preview-area/components/preview-area-header/preview-area-header";
import PreviewAreaContent from "containers/admin/clients/client/theme-page/preview/preview-area/components/preview-area-content/preview-area-content";
import { IconButton } from "ui/icon-button";

import Icons from "assets";

const PreviewArea = () => {
  const { viewMode, isSettingsOpen, setIsSettingsOpen } = useThemePreviewContext();
  const isMobileView = viewMode === "Mobile";

  // Get client
  const client = useCurrentClient();

  return (
    <div className="flex relative">
      <div
        className={classNames("flex flex-col gap-3 pl-6 py-8 flex-1", {
          "pr-6": isSettingsOpen,
          "pr-12": !isSettingsOpen,
        })}>
        <span className="font-bold text-gray-500 text-sm tracking-widest -mt-1">PREVIEW</span>
        <div
          className={`border border-neutrals-200 ${isMobileView ? "max-w-[25rem]" : "max-w-full"}`}>
          <PreviewAreaHeader isMobileView={isMobileView} />
          <PreviewAreaContent isMobileView={isMobileView} clientName={client.name} />
        </div>
      </div>
      <div className="fixed right-5 pt-4">
        {!isSettingsOpen && (
          <IconButton
            aria-label="Open settings"
            variant="text"
            onClick={() => setIsSettingsOpen(true)}>
            <Icons.Sidebar className="text-neutrals-500" />
          </IconButton>
        )}
      </div>
    </div>
  );
};

export default PreviewArea;
